import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {TableSelectionAbstract} from '../../../../../shared/component/table/table-selection.abstract';
import {Form, FormBuilder, FormGroup} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {NzModalService} from 'ng-zorro-antd/modal';
import {GeneralService} from '../../../../../service/general-service';
import {NotificationService} from '../../../../../service/notification.service';
import {AppConfigService} from '../../../../../../app-config.service';
import {ShareaService} from '../../../../../service/sharea.service';
import {Title} from '@angular/platform-browser';
import {Constant} from '../../../../../shared/constants/constant.class';
import {WarehouseService} from '../../../../../service/warehouse.service';

@Component({
  selector: "app-inventory-reconcilation",
  templateUrl: "./inventory-reconcilation.component.html",
  styleUrls: ["./inventory-reconcilation.component.scss"],
})
export class InventoryReconcilationComponent
  extends TableSelectionAbstract
  implements OnInit
{
  @Input() enableEditChemical: boolean;
  @ViewChild("spreadsheet") detailTable: ElementRef;
  @ViewChild("inputElement", { static: false }) inputElement?: ElementRef;
  datas: any[] = [];
  users: any[] = [];
  warehouseInventoryResults: any[] = [];
  chemicals: any[] = [];
  inputUsers: any[] = [];
  formAdd: FormGroup;
  filterForm: FormGroup;
  isVisibleAdd = false;
  isVisibleUpdate: boolean;
  searchText: any;
  data: any = {};
  loading: boolean;
  checkAdd = true;
  page: any;
  pageSize: any;
  defaultPage: any;
  checkDelete = true;
  checkUpdate = true;
  checkDetails = true;
  item: any = {};
  isVisible = false;
  isLoading: boolean;
  isVisibleChemical: boolean;
  value = "";
  title = "0...";
  enableEdit = true;
  isVisibleViewDetail = false;
  isVisibleViewScan = false;
  isVisibleScan = false;
  loadingButton: boolean;
  dataView = {
    id: "",
    code: "",
    description: "",
    supplier: "",
    paymentAmount: "",
    paymentCode: "",
    chemicalId: "",
    isProcessed: false,
  };
  categories: any;
  arrBarcodes: any[];
  treeChemicals: any[] = [];
  userInfo: any;
  total: number;
  resultItem: any;
  successCount: number;
  totalInventory: number;
  listChemicalId: any[] = [];
  listUserId: any[] = [];
  logs: any[] = [];
  selectedWarehouseId: any;
  constructor(
    public translate: TranslateService,
    private modalService: NzModalService,
    private generalService: GeneralService,
    private notificationService: NotificationService,
    private fb: FormBuilder,
    private configService: AppConfigService,
    private warehouseService: WarehouseService,
    private shareaService: ShareaService,
    private titleService: Title
  ) {
    super("id");
    this.formAdd = this.fb.group({
      id: [null],
      code: [null],
      description: [null],
      supplier: [null],
      paymentAmount: [null],
      paymentCode: [null],
      chemicalId: [null],
      inputUserId: [null],
    });
    this.filterForm = this.fb.group({
      fromDate: [null],
      toDate: [null],
    });
    this.arrBarcodes = [];
    this.selectedWarehouseId = +localStorage.getItem(Constant.WAREHOUSE_ID);
  }

  ngOnInit(): void {
    this.pageSize = this.configService.getConfig().pageSize;
    this.page = this.configService.getConfig().page;
    this.defaultPage = this.configService.getConfig().defaultPage;
    this.get();
    this.getUserName();
    this.getListCategory();
    this.getChemicalsList();
    this.getListData();
    this.userInfo = JSON.parse(localStorage.getItem(Constant.USER_INFO));
  }

  get formData() {
    return this.formAdd.controls;
  }

  getListData() {
    this.loading = true;
    const filter = {
      page: this.page,
      pageSize: this.defaultPage,
      fromDate: this.filterForm.value.fromDate,
      toDate: this.filterForm.value.toDate,
      wareHouseId: this.selectedWarehouseId,
    };
    this.generalService.getWarehouseInventory(filter).subscribe(
      (res) => {
        if (res !== null) {
          this.datas = res.data;
          this.total = res.total;
          super.setListOfAllData(this.datas);
          this.loading = false;
        }
      },
      (error) => {}
    );
  }

  doSearch() {
    this.getListData();
  }

  get() {
    this.translate.use(this.translate.currentLang).subscribe((data) => {
      this.data = data;
    });
  }

  getChemicalsList() {
    this.generalService.getChemical().subscribe(
      (res) => {
        if (res !== null) {
          this.chemicals = res;
        }
      },
      (error) => {}
    );
  }

  getListCategory() {
    this.generalService.getCategoryWithChemical().subscribe(
      (res) => {
        if (res !== null) {
          this.categories = res;
          const allChemical = [];
          const childrens = [];
          res.forEach((en) => {
            const cat = {
              title: en.name,
              value: "c" + en.id,
              key: "c" + en.id,
              isLeaf: false,
              children: [],
            };
            allChemical.push(cat.value)
            childrens.push(cat);
            en.chemicals.forEach((item) => {
              cat.children.push({
                title: item.name,
                value: item.id,
                key: item.id,
                isLeaf: true,
              });
            });
          });
          this.treeChemicals = [
            {
              title: "--Tất cả--",
              value: [],
              key: [],
              children: childrens,
            },
          ];
          allChemical.forEach((en) => {
            this.treeChemicals[0].value.push(en)
            this.treeChemicals[0].key.push(en);
          })
          console.log(this.treeChemicals);
        }
      },
      (error) => {}
    );
  }

  getUserName() {
    this.generalService.getTaikhoan().subscribe(
      (res) => {
        if (res !== null) {
          this.inputUsers = res;
          this.inputUsers = this.inputUsers.filter((en) =>
            en.userRoles.find((x) => x.roleId === 17)
          );
        }
      },
      (error) => {}
    );
  }

  showModalChemical(data) {
    this.isVisibleChemical = true;
    this.item = data;
    this.chemicals = this.item.chemicallists;
  }

  showConfirm(id): void {
    this.get();
    this.modalService.confirm({
      nzTitle: "Confirm",
      nzContent: "Bạn có muốn xóa hay không?",
      nzOkText: "Đồng ý",
      nzCancelText: "Bỏ qua",
      nzOnOk: () => this.deleteItem(id),
    });
  }
  checkInventoryComplete(data) {
    if (data.isOk) {
      this.completeInventory(data);
    } else {
      this.showConfirmComplete(data);
    }
  }
  showConfirmComplete(data): void {
    this.get();
    this.modalService.confirm({
      nzTitle: "Confirm",
      nzContent:
        "Số lượng kiểm kê không khớp với tồn kho. Bạn có chắc muốn kết thúc quá trình kiểm kê không?",
      nzOkText: "Đồng ý",
      nzCancelText: "Bỏ qua",
      nzOnOk: () => this.completeInventory(data),
    });
  }
  showConfirmCompleteSuccess(data): void {
    this.get();
    this.modalService.confirm({
      nzTitle: "Confirm",
      nzContent:
        "Số lượng kiểm kê đã khớp. Bạn có muốn kết thúc quá trình kiểm kê không?",
      nzOkText: "Đồng ý",
      nzCancelText: "Bỏ qua",
      nzOnOk: () => this.completeInventory(data),
    });
  }

  deleteItem(id) {
    this.generalService.deleteWarehouseImport(id).subscribe(
      (res) => {
        this.notificationService.showNotification(
          Constant.SUCCESS,
          Constant.MESSAGE_DELETE_SUCCESS
        );
        this.getListData();
      },
      (error) => {}
    );
  }

  showModalAdd() {
    this.isVisibleAdd = true;
    this.warehouseInventoryResults = [];
    this.item = {};
    const me = this.inputUsers.find((en) => en.id === this.userInfo.id);
    this.listChemicalId = [];
    this.listUserId = [this.userInfo.id];
    console.log(this.item.listUserId);
  }

  showModalUpdate(data) {
    this.enableEdit = true;
    this.isVisibleAdd = true;
    this.item = data;
    this.warehouseInventoryResults = data.warehouseInventoryResults;
    this.formAdd.patchValue({
      id: data.id,
      code: data.code,
      description: data.description,
      supplier: data.supplier,
      paymentAmount: data.paymentAmount,
      paymentCode: data.paymentCode,
      chemicalId: data.chemicalId,
    });
  }

  showDetails(data) {
    this.item = data;
    this.dataView = data;
    if (data.inventoryStatus !== 1) {
      this.isVisibleViewDetail = true;
      this.warehouseInventoryResults = data.warehouseInventoryResults;
      console.log("showDetails", this.dataView, "data", data);
    } else {
      this.isVisibleViewScan = true;
      this.getAllInventoryById(data.id);
    }
  }

  handleCancel() {
    this.isVisibleAdd = false;
  }

  handleCancelView() {
    this.isVisibleViewDetail = false;
  }

  handleOk() {
    console.log(Array.isArray(this.listChemicalId[0]));
    if (Array.isArray(this.listChemicalId[0])) {
      this.item.listChemicalId = this.listChemicalId[0];
    } else this.item.listChemicalId = this.listChemicalId;
    // this.item.listChemicalId = this.listChemicalId;
    this.item.listUserId = this.listUserId;
    this.item.wareHouseId = this.selectedWarehouseId;
    if (!this.item.listUserId.length) {
      this.notificationService.showNotification(
        Constant.ERROR,
        "Chưa chọn người thực hiện"
      );
      return;
    }
    if (!this.item.listChemicalId || !this.item.listChemicalId.length) {
      this.notificationService.showNotification(
        Constant.ERROR,
        "Chưa chọn danh mục vật tư cần kiểm kê"
      );
      return;
    }
    this.generalService.addWarehouseInventory(this.item).subscribe(
      (res) => {
        this.loadingButton = false;
        if (
          res !== null &&
          res !== undefined &&
          res.ret !== null &&
          res.ret !== undefined &&
          res.ret.code !== 0
        ) {
          this.notificationService.showNotification(
            Constant.ERROR,
            res.ret[0].message
          );
        } else {
          this.listChemicalId = [];
          this.getListData();
          this.isVisibleAdd = false;
          this.notificationService.showNotification(
            Constant.SUCCESS,
            Constant.MESSAGE_ADD_SUCCESS
          );
        }
      },
      (error) => {
        this.notificationService.showNotification(
          Constant.ERROR,
          Constant.MESSAGE_SERVICE_ERROR
        );
      }
    );
  }

  deleteDetail(id) {
    this.warehouseInventoryResults = this.warehouseInventoryResults.filter(
      (en) => en.chemicalId !== id
    );
  }

  getRowIndex = (index, pageIndex, pageSize) =>
    index + 1 + pageSize * (pageIndex - 1);

  calculateTotal(data: any) {
    setTimeout(() => {
      // <<<---using ()=> syntax
      data.totalPrice = data.price * data.amount;
    }, 100);
  }

  chemicalsChange($event: any) {
    console.log($event[0].length);
  }

  toStatusText(status: number) {
    switch (status) {
      case 0:
        return "Mới tạo";
      case 1:
        return "Đang xử lý";
      case 2:
        return "Đã hoàn thành";
    }
  }

  toResult(data) {
    if (data.inventoryStatus === 2) {
      return `Chênh lệch ${
        data.totalShortage + data.totalRedundancy
      } (hộp/lọ) vật tư (Thiếu: ${data.totalShortage}, thừa ${
        data.totalRedundancy
      })`;
    } else if (data.inventoryStatus === 1 && data.totalInventoryed !== null) {
      return `Đang kiểm kê được ${data.totalInventoryed}/${data.totalInventory} (hộp/lọ) vật tư`;
    }
  }

  toWarningClass(data) {
    if (data.inventoryStatus === 2) {
      if (data.totalShortage + data.totalRedundancy > 0) {
        return "warning";
      } else {
        return "success";
      }
    }
    return "status-" + data.inventoryStatus;
  }

  handleCancelScan() {
    this.isVisibleScan = false;
  }

  startInventory(data: any) {
    this.item = data;
    this.resultItem = null;
    this.generalService.startInventory(this.item.id).subscribe(
      (res) => {
        this.loadingButton = false;
        if (
          res !== null &&
          res !== undefined &&
          res.ret !== null &&
          res.ret !== undefined &&
          res.ret.code !== 0
        ) {
          this.notificationService.showNotification(
            Constant.ERROR,
            res.ret[0].message
          );
        } else {
          this.notificationService.showNotification(
            Constant.SUCCESS,
            "Bắt đầu kiểm kê thành công. Lượt kiểm kê đang được tiến hành"
          );
          this.isVisibleScan = true;
          this.successCount = 0;
          this.doSearch();
        }
      },
      (error) => {
        this.notificationService.showNotification(
          Constant.ERROR,
          Constant.MESSAGE_SERVICE_ERROR
        );
      }
    );
  }

  doScan() {
    this.resultItem = null;
    this.logs = [];
    // console.log(this.item);
    if (this.item.barcode.length !== 8) {
      return;
    }
    this.generalService
      .processInventory({
        warehouseInventoryId: this.item.id,
        code: this.item.barcode,
      })
      .subscribe(
        (res) => {
          if (res !== null) {
            this.item.barcode = "";
            console.log(res);
            if (res !== null && res.isValid === false) {
              this.resultItem = {
                chemical: res.data ? res.data.chemical : null,
                batchNumber: res.data ? res.data.batchNumber : null,
                expiredDate: res.data ? res.data.expiredDate : null,
                serialNumber: res.data ? res.data.serialNumber : null,
                packingType: res.data ? res.data.packingType : null,
                unitTypeText: res.data ? res.data.unitTypeText : null,
                lotNumber: res.data ? res.data.lotNumber : null,
                parcelDetailCode: res.data ? res.data.parcelDetailCode : null,
                errorMessage: res.errors[0].errorMessage,
                isValid: false,
              };
            } else {
              this.resultItem = {
                chemical: res.data.chemical,
                batchNumber: res.data.batchNumber,
                expiredDate: res.data.expiredDate,
                serialNumber: res.data.serialNumber,
                packingType: res.data.packingType,
                unitTypeText: res.data.unitTypeText,
                lotNumber: res.data.lotNumber,
                parcelDetailCode: res.data.parcelDetailCode,
                isValid: true,
              };
              this.isVisibleScan = true;
              this.successCount = res.data.totalInventoryed;
              this.totalInventory = res.data.totalInventory;
              if (this.successCount === this.totalInventory) {
                this.showConfirmCompleteSuccess(this.item);
              }
            }
          }
        },
        (error) => {}
      );
  }

  popupInventory(data: any) {
    this.successCount = 0;
    this.item = data;
    this.isVisibleScan = true;
    this.resultItem = null;
    this.successCount = data.totalInventoryed;
    this.totalInventory = data.totalInventory;
  }

  confirmComplete(data): void {
    this.get();
    this.modalService.confirm({
      nzTitle: "Confirm",
      nzContent: "Bạn có muốn kết thúc lượt kiểm kê này không?",
      nzOkText: "Đồng ý",
      nzCancelText: "Bỏ qua",
      nzOnOk: () => this.completeInventory(data),
    });
  }

  completeInventory(data: any) {
    this.item = data;
    this.generalService.completeInventory(data.id).subscribe(
      (res) => {
        if (res !== null) {
          if (
            res !== null &&
            res !== undefined &&
            res.ret !== null &&
            res.ret !== undefined &&
            res.ret.code !== 0
          ) {
            this.notificationService.showNotification(
              Constant.ERROR,
              res.ret[0].message
            );
          } else {
            this.notificationService.showNotification(
              Constant.SUCCESS,
              `Đã hoàn thành lượt kiểm kê: ${data.reason}`
            );
            this.isVisibleScan = false;
            this.doSearch();
          }
        }
      },
      (error) => {}
    );
  }

  showLog(item: any) {
    console.log(item);
    if (item && item.parcelDetailCode) {
      this.generalService.getInventoryHistory(item.parcelDetailCode).subscribe(
        (res) => {
          if (res !== null) {
            console.log(res);
            this.logs = res.logs;
          }
        },
        (error) => {}
      );
    }
  }
  getAllInventoryById(id) {
    this.generalService.getAllInventoryById(id).subscribe(
      (resOK) => {
        console.log(resOK);
        this.warehouseInventoryResults = resOK;
      },
      (error) => {}
    );
  }

  handleCancelScanDetail() {
    this.isVisibleViewScan = false;
  }

  fixShortage() {
    const reason = prompt("Nhập lý do:");
    const item = {
      warehouseInventoryId: this.dataView.id,
      reason,
    };
    console.log(reason);
    if (reason) {
      this.warehouseService.processShortage(item).subscribe(
        (resOK) => {
          console.log(resOK);
          this.warehouseInventoryResults = resOK;
        },
        (error) => {}
      );
    }
  }
}

